import React, { useState } from "react";

const ResuestSample = ({ formData, setFormData }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const testOptions = [
    
    { value: "Blood", label: "Blood" },
    { value: "Urine", label: "Urine" },
    { value: "Stool", label: "Stool" },
    { value: "Saliva",label:"Saliva" },
  ];

  const filteredOptions = testOptions.filter((test) =>
    test.label.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleSelect = (test) => {
    setFormData((prev) => {
      const currentRequiredTests = Array.isArray(prev.SerumTypes) ? prev.SerumTypes : [];

      const exists = currentRequiredTests.find((t) => t.value === test.value);
      if (exists) {
        return {
          ...prev,
         SerumTypes: currentRequiredTests.filter((t) => t.value !== test.value),
        };
      } else {
        return {
          ...prev,
         SerumTypes: [...currentRequiredTests, { ...test, fasting: false }],
        };
      }
    });
  };

  const isSelected = (test) => {
    const currentRequiredTests = Array.isArray(formData.SerumTypes) ? formData.SerumTypes : [];
    return currentRequiredTests.some((t) => t.value === test.value);
  };

  return (
    <>
      {/* Main Button to trigger the popup */}
      <button
      type="button"
        className="w-full py-[10px] px-4 border-[#4ab0b0] border-[1px] rounded-lg"
        onClick={() => setIsDropdownOpen(true)}
      >
        {formData.SerumTypes?.length > 0
          ? `${formData.SerumTypes.length} Sample Selected`
          : "Sample Types"}
      </button>

      {isDropdownOpen && (
        <div className="fixed inset-0 z-30 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-[#11485B] md:w-[50%] w-[90%] h-[50%]  p-4 rounded-lg shadow-lg relative">
          <button
          type="button"
              className="absolute top-0 right-2 text-4xl text-gray-500"
              onClick={() => setIsDropdownOpen(false)}
            >
              &times;
            </button>

            <div className="p-4">
              <input
                className="w-full py-2 px-4 border rounded-lg"
                type="text"
                placeholder="Search Tests"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>

            <div className="px-2 h-[70%] overflow-y-auto">
              {filteredOptions.map((test) => (
                <div key={test.value} className="flex items-center p-2 hover:bg-gray-100 hover:text-black">
                  <div className="flex items-center justify-center w-10">
                    <input
                      type="checkbox"
                      checked={isSelected(test)}
                      onChange={() => handleSelect(test)}
                    />
                  </div>
                  <label
                    className="cursor-pointer"
                    onClick={() => handleSelect(test)}
                  >
                    {test.label}
                  </label>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ResuestSample;
